import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type User } from './DataSlice'

const initialState = {
  jwt: undefined as string | undefined,
  user: undefined as User | undefined,
}
const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setJwt(state, action: PayloadAction<string | undefined>) {
      state.jwt = action.payload
    },
    setUser(state, action: PayloadAction<User | undefined>) {
      state.user = action.payload
    },
    logout(state) {
      state.jwt = undefined
      state.user = undefined
    },
  },
})
export const { setJwt, setUser, logout } = authenticationSlice.actions

export default authenticationSlice.reducer
